const dashboardColors = [
    "#427FBA",
    "#6FA7DF",
    "#687687",
    "#005DA1",
    "#AAAFBA",
    "#62789C",
    "#5B9CD4",
    "#888888",
    "#005EA0",
    "#E3E4E8",
];

export default dashboardColors